import store from 'Stores';

// eslint-disable-next-line import/prefer-default-export
export function bioConstraint() {
  return !store.getters['subscriptionBasket/getProductSelectorsV2'].filter((b) => b.isBio).length;
}
